import segment from 'common/segment';

const PRODUCT_LIST_VIEWED = 'Product List Viewed';
const PRODUCT_VIEWED = 'Product Viewed';

const removeTrailingSlash = str => str.replace(/\/$/, '');

// Extract the variants from window.gon.products
// and flatten them together into a contiguous array.
export const getVariants = () =>
  (window.gon.products || [])
    .map(product => product.variants)
    .reduce((accum, list) => [...accum, ...list]); //Flatten array of arrays.

// Create the segment e-commerce product object. Our currently used destination
// only needs to know the SKU. We can add extra fields later if necessary.
export const buildSegmentProduct = gonVariant => ({
  sku: gonVariant.sku,
});

export const trackCatalog = () => {
  segment.track(PRODUCT_LIST_VIEWED, {
    products: getVariants().map(buildSegmentProduct),
  });
};

export const trackGallery = (pathname = window.location.pathname) => {
  // Gallery pages have URLs of the form: /shop/:category. Thus, lets
  // extract the right most "part" of the URL.
  const category = removeTrailingSlash(pathname)
    .split('/')
    .pop();
  segment.track(PRODUCT_LIST_VIEWED, {
    products: getVariants()
      .filter(variant => variant.category === category)
      .map(buildSegmentProduct),
  });
};

export const trackPDP = (pathname = window.location.pathname) => {
  const noTrailing = removeTrailingSlash(pathname);
  const variant = getVariants().find(x => x.url === noTrailing);
  if (variant) segment.track(PRODUCT_VIEWED, buildSegmentProduct(variant));
};
